import React from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import "./audits.css";

const AuditsTable = ({ companyData }) => {
  const certifications = companyData?.certificationIds || [];

  // Columns for the main (certificate) table
  const columns = [
    {
      title: "Certificate Number",
      dataIndex: "certificationNumber",
      key: "certificationNumber",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
      render: () => companyData?.companyName || "-",
    },
    {
      title: "Date of Registration",
      dataIndex: "dateOfRegistration",
      key: "dateOfRegistration",
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "-"),
    },
  ];

  // Calculate days remaining
  const calculateDaysRemaining = (dueDate) => {
    if (!dueDate) return "-";
    const today = dayjs();
    const diff = dayjs(dueDate).diff(today, "day");
    return diff >= 0 ? diff : `-${Math.abs(diff)}`;
  };

  // Expanded nested table for audits
  const expandedRowRender = (record) => {
    const data = [
      {
        key: "1",
        audittype: "1st Surveillance",
        duedate: dayjs(record.firstSurveillanceAudit).format("DD-MM-YYYY"),
        daysremaining: calculateDaysRemaining(record.firstSurveillanceAudit),
        status: record.firstSurveillanceStatus,
        auditornotes:
          record.firstSurveillanceNotes || "No notes available",
      },
      {
        key: "2",
        audittype: "2nd Surveillance",
        duedate: dayjs(record.secondSurveillanceAudit).format("DD-MM-YYYY"),
        daysremaining: calculateDaysRemaining(record.secondSurveillanceAudit),
        status: record.secondSurveillanceStatus,
        auditornotes:
          record.secondSurveillanceNotes || "No notes available",
      },
    ];

    const auditColumns = [
      {
        title: "Audit Type",
        dataIndex: "audittype",
        key: "audittype",
      },
      {
        title: "Due Date",
        dataIndex: "duedate",
        key: "duedate",
      },
      {
        title: "Days Remaining",
        dataIndex: "daysremaining",
        key: "daysremaining",
        render: (days) => {
          const isOverdue = parseInt(days) < 0;
          return (
            <span style={{ color: isOverdue ? "#FF4D4F" : "#0CBC53" }}>
              {days}
            </span>
          );
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => {
          const lowerStatus = status?.toLowerCase();
          let bgColor = "";
          let textColor = "";

          if (lowerStatus === "completed") {
            bgColor = "#DFF6E4";
            textColor = "#0CBC53";
          } else if (lowerStatus === "pending") {
            bgColor = "#FFF4E5";
            textColor = "#FFA500";
          } else {
            bgColor = "#FDEAEA";
            textColor = "#FF4D4F";
          }

          return (
            <span
              style={{
                backgroundColor: bgColor,
                color: textColor,
                padding: "4px 10px",
                borderRadius: "12px",
                fontWeight: 500,
                display: "inline-block",
                minWidth: "70px",
                textAlign: "center",
              }}
            >
              {status}
            </span>
          );
        },
      },
      {
        title: "Auditor Notes",
        dataIndex: "auditornotes",
        key: "auditornotes",
      },
    ];

    return (
      <Table
        columns={auditColumns}
        dataSource={data}
        pagination={false}
        size="small"
      />
    );
  };

  return (
    <div className="audit-table mt-3">
      <Table
        columns={columns}
        dataSource={certifications}
        expandable={{
          expandedRowRender,
          rowExpandable: (record) => true,
        }}
        pagination={{
          pageSize: 3,
          total: certifications.length,
          className: "custom-pagination",
        }}
        rowKey={(record) => record._id}
      />
    </div>
  );
};

export default AuditsTable;
